import { render } from "./DeployToken.vue?vue&type=template&id=ca510fe2"
import script from "./DeployToken.vue?vue&type=script&lang=js"
export * from "./DeployToken.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__